import { Box, Typography } from "@mui/material";
import { togglePorps } from "components/types";
import * as React from "react";
import { useState } from "react";

const Toggle: React.FC<togglePorps> = ({
  handleToggle,
  label,
  active,
  element1,
  element2,
  element3,
}) => {
  const [selectedSide, setSelectedSide] = useState(active);

  const selectedStyles = {
    background:
      selectedSide === active
        ? "linear-gradient(90deg, #044E82 0%, #2B94DC 100%)"
        : "linear-gradient(270deg, #044E83 0%, #2B94DD 100%)",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    color: "white",
  };

  const notSelectedStyles = {
    background: "#FFFFFF",
    border: "none",
    outline: "1px solid rgba(208, 208, 208, 1)",
    display: "flex",
    padding: "8px",
    alignItems: "center",
    justifyContent: "center",
    outlineOffset: "-1px",
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        pointerEvents: "auto",
      }}
    >
      {label && <Typography sx={{ margin: "0 10px" }}>{label}</Typography>}
      <Box sx={{ display: "flex", height: "45px" }}>
        <Box
          onClick={() => {
            handleToggle(2);
            setSelectedSide(2);
          }}
          sx={{ cursor: "pointer" }}
          style={Object.assign(
            { borderRadius: "6px 0 0 6px" },
            selectedSide === 2 ? selectedStyles : notSelectedStyles
          )}
        >
          {element1}
        </Box>

        <Box
          onClick={() => {
            handleToggle(1);
            setSelectedSide(1);
          }}
          sx={{ cursor: "pointer" }}
          style={Object.assign(
            selectedSide === 1 ? selectedStyles : notSelectedStyles
          )}
        >
          {element2}
        </Box>
        {element3 && (
          <Box
            onClick={() => {
              handleToggle(3);
              setSelectedSide(3);
            }}
            sx={{ cursor: "pointer" }}
            style={Object.assign(
              { borderRadius: "0 6px 6px 0" },
              selectedSide === 3 ? selectedStyles : notSelectedStyles
            )}
          >
            {element3}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Toggle;
